export function getWindow() {
    // @ts-ignore
    if (typeof window !== "undefined")
        return window;
}
export function getNavigator() {
    // @ts-ignore
    if (typeof navigator !== "undefined")
        return navigator;
}
export function getGlobal() {
    var _a;
    return ((_a = getWindow()) !== null && _a !== void 0 ? _a : 
    // @ts-ignore
    typeof WorkerGlobalScope !== "undefined")
        ? // @ts-ignore
            self
        : typeof global !== "undefined"
            ? global
            : Function("return this;")();
}
const _navigator = getNavigator();
const _window = getWindow();
export function detect(info = {
    ios: false,
    macos: false,
    windows: false,
    beaker: false,
    electron: false,
    wkwebview: false,
    pwa: false,
    pwaInstalled: false,
    browser: false,
    node: false,
    worker: false,
    jest: false,
    macosNative: false,
    iosNative: false,
    appleNative: false,
    touch: false,
}) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    info.ios = ((_a = _navigator === null || _navigator === void 0 ? void 0 : _navigator.platform) === null || _a === void 0 ? void 0 : _a.match(/(iPhone|iPod|iPad)/i)) != null;
    info.macos = !!((_b = _navigator === null || _navigator === void 0 ? void 0 : _navigator.platform) === null || _b === void 0 ? void 0 : _b.startsWith("Mac"));
    info.windows = !!((_c = _navigator === null || _navigator === void 0 ? void 0 : _navigator.platform) === null || _c === void 0 ? void 0 : _c.startsWith("Win"));
    // @ts-ignore
    info.beaker = (_window === null || _window === void 0 ? void 0 : _window["beaker"]) != null; // https://github.com/beakerbrowser/beaker
    info.electron =
        (((_e = (_d = _navigator === null || _navigator === void 0 ? void 0 : _navigator.userAgent) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.indexOf(" electron/")) || -1) > -1 &&
            !info.beaker;
    // @ts-ignore
    info.wkwebview = ((_f = _window === null || _window === void 0 ? void 0 : _window.webkit) === null || _f === void 0 ? void 0 : _f["messageHandlers"]) != null; //Apple embedded
    info.pwa = (_navigator === null || _navigator === void 0 ? void 0 : _navigator.serviceWorker) != null;
    info.pwaInstalled =
        // @ts-ignore
        (_navigator === null || _navigator === void 0 ? void 0 : _navigator.standalone) ||
            ((_g = _window === null || _window === void 0 ? void 0 : _window.matchMedia("(display-mode: standalone)")) === null || _g === void 0 ? void 0 : _g.matches);
    info.node =
        typeof process !== "undefined" && ((_h = process === null || process === void 0 ? void 0 : process.release) === null || _h === void 0 ? void 0 : _h.name) === "node";
    info.browser = !info.electron && !info.wkwebview && !info.node;
    // info.worker = typeof importScripts === 'function'
    // @ts-ignore
    info.worker =
        // @ts-ignore
        typeof WorkerGlobalScope !== "undefined" &&
            // @ts-ignore
            self instanceof WorkerGlobalScope;
    // @ts-ignore
    info.jest = typeof jest !== "undefined";
    info.macosNative = info.wkwebview && info.macos;
    info.iosNative = info.wkwebview && info.ios;
    info.appleNative = info.wkwebview;
    // https://github.com/viljamis/feature.js/blob/master/feature.js#L203
    // @ts-ignore
    info.touch =
        (_window && "ontouchstart" in _window) ||
            ((_navigator === null || _navigator === void 0 ? void 0 : _navigator.maxTouchPoints) || 0) > 1 ||
            // @ts-ignore
            ((_navigator === null || _navigator === void 0 ? void 0 : _navigator.msPointerEnabled) && (_window === null || _window === void 0 ? void 0 : _window.MSGesture)) ||
            // @ts-ignore
            ((_window === null || _window === void 0 ? void 0 : _window.DocumentTouch) && document instanceof DocumentTouch);
    return info;
}
export const platform = detect();
export function subscribeDetectOrientation(fn) {
    const mediaQuery = _window === null || _window === void 0 ? void 0 : _window.matchMedia("(orientation: landscape)");
    const emit = () => {
        const landscape = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches;
        fn({
            landscape,
            portrait: !landscape,
            orientation: landscape ? "landscape" : "portrait",
        });
    };
    emit();
    mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener("change", emit);
}
//# sourceMappingURL=platform.js.map